export const exportHeaders = [
    {
        label: "Email Type",
        key: "email_type"
    },

    {
        label: "Status",
        key: "status"
    },


    {
        label: "Date",
        key: "run_date"
    },

    {
        label: "Start",
        key: "start_time"
    },

    {
        label: "End",
        key: "end_time"
    },

    {
        label: "Member ID",
        key: "loyalty_id"
    },

    {
        label: "Account Status",
        key: "Loyalty_Account.is_active"
    },

    {
        label: "Consent Flag",
        key: "Loyalty_Account.consent_flag"
    },
    {
        label: "Process Type",
        key: "process_type"
    },
   


]